var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"checkbox-wrapper"},[_c('div',{staticClass:"input g-visually-hidden",class:{ checked: _vm.checked, disabled: _vm.disabled },attrs:{"id":_vm.getId}}),_c('label',{staticClass:"label",attrs:{"for":_vm.getId}},[_c('span',{staticClass:"checkbox",class:{ disabled: _vm.disabled }})])])
}
var staticRenderFns = []

export { render, staticRenderFns }